<template>
  <IconLucideUsers />
</template>
